const Faqs = [
	{
		id: '1',
		title: 'What is an API?',
		body: 'An Application Programming Interface (API) is a structured programming code that allows data transmission from one software product to another internally or externally.',
	},
	{
		id: '2',
		title: ' What APIs are available on DevAsk?',
		body: 'Internal APIs are designed for data transmission and to improve solutions within an organisation. External APISs are majorly used by third party developers and can be classified as a public API',
	},
	{
		id: '3',
		title: ' What can DevAsk be used for?',
		body: 'Internal APIs are designed for data transmission and to improve solutions within an organisation.',
	},
	{
		id: '4',
		title:
			'I have an app and I want to connect to an API, what do I need to start?',
		body: 'To get started with working with External Api, you need to find an HTTP client online that you can work with. Examples of existing ones are Postman or REST clients. Familiarize yourself with these tools by accessing their documentation on their site. Attached is a resource to guide you further RESTFUL API',
	},
];

export default Faqs;
